export default {
  layout: {
    viewTitle: "Layout",
    tabTitle: "Layout",
  },
};
